import React from 'react'
import styles from './createItem.module.sass'
import ItemInfo from './ItemInformation'
import ItemAction from './ItemAction'
import { ToastContainer } from "react-toastify";

const CreateItems = ({isChanged, setIsChanged}) => {
  return (
    <>
      <ToastContainer />
      <div className={styles.row}>
        <div className={styles.col}>
            <ItemInfo isChanged={isChanged} setIsChanged={setIsChanged} className={styles.card}/>
        </div>
      </div>
    </>
  )
}

export default CreateItems